import wBadge from './w-badge.vue';

import { installer } from '#util';

export const Badge = { install: installer([wBadge]) };
export { wBadge };
